import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Container } from "./shared";
import { SectionHeader } from "./Problem";

const INCLUDED = ["Unlimited project requests", "AI scope, price range and red flags", "Hot / Warm / Cold lead scoring", "Instant email alerts", "Branded quote link with your logo", "Visit checklist and quick text replies"];

const FAQ = [
  ["Does the homeowner see the price estimate?", "No. The price range is only for you. Homeowners just see a thank-you message with your company name."],
  ["How accurate is the AI price range?", "It's a preliminary range to help you decide whether to visit, not a quote. Add your own base prices per service in Settings and the AI uses them for sharper estimates."],
  ["Do homeowners need to download an app?", "No. They open your link in any phone browser, take photos and submit in a couple of minutes."],
  ["What happens after the 14-day trial?", "You can subscribe for $99/month to keep your link live. There's no contract and you can cancel anytime from Settings."],
  ["Can I use my own logo and colors?", "Yes. Upload your logo, pick your brand color and choose your link name, like /q/your-company."],
];

export const Pricing = () => (
  <section id="pricing" className="py-20 sm:py-28" data-testid="landing-pricing">
    <Container className="grid gap-12 lg:grid-cols-2 lg:items-center">
      <SectionHeader eyebrow="Pricing" title="One plan. Everything included." sub="Less than the cost of one wasted estimate visit a month." />
      <div className="rounded-3xl border-2 border-slate-900 bg-white p-7 shadow-[8px_8px_0_0_#0f172a]" data-testid="pricing-card">
        <p className="text-sm font-bold uppercase tracking-wider text-slate-500">Squadrum Standard</p>
        <p className="mt-2 font-display text-5xl font-extrabold text-slate-900" data-testid="pricing-price">$99<span className="text-lg font-semibold text-slate-500">/month</span></p>
        <p className="mt-2 text-sm font-semibold text-[color:var(--brand)]">14 days free · No contract · Cancel anytime</p>
        <ul className="mt-6 space-y-2.5">
          {INCLUDED.map((f) => <li key={f} className="flex items-center gap-2.5 text-[15px] text-slate-700"><Check className="h-5 w-5 shrink-0 text-emerald-600" />{f}</li>)}
        </ul>
        <Link to="/register" data-testid="pricing-cta-button"
          className="mt-7 flex h-14 items-center justify-center rounded-xl bg-[color:var(--brand)] text-lg font-semibold text-white transition-transform active:scale-[0.98]">
          Start your 14-day free trial
        </Link>
      </div>
    </Container>
  </section>
);

export const Faq = () => (
  <section id="faq" className="border-t border-slate-200 bg-white py-20 sm:py-28" data-testid="landing-faq">
    <Container className="grid gap-10 lg:grid-cols-[1fr_1.4fr]">
      <SectionHeader eyebrow="FAQ" title="Questions pros ask." />
      <Accordion type="single" collapsible className="w-full">
        {FAQ.map(([q, a], i) => (
          <AccordionItem key={q} value={`q${i}`} data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="py-5 text-left font-display text-base font-bold text-slate-900 hover:no-underline" data-testid={`faq-trigger-${i}`}>{q}</AccordionTrigger>
            <AccordionContent className="text-[15px] leading-relaxed text-slate-600">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Container>
  </section>
);
